import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="px-4 md:px-6 py-4 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-5 bg-primary-100 rounded-2xl">
              <i className="ri-movie-2-fill text-3xl text-primary-500"></i>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              关于努努影院
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
              努努影院成立于2018年，是国内领先的高清电视剧免费在线观看平台。我们致力于为广大追剧爱好者提供最全面、最流畅的观剧体验，让每一位观众都能轻松找到自己喜欢的电视剧。
            </p>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {[
                {
                  icon: 'ri-shield-star-line',
                  title: '高清画质',
                  desc: '全部资源采用高清编码，支持1080P超清画质，让您享受影院级观影体验，每一帧都清晰动人。',
                },
                {
                  icon: 'ri-speed-up-line',
                  title: '流畅不缓冲',
                  desc: '多线CDN加速服务器部署，智能选择最优线路，确保播放过程流畅稳定，告别卡顿烦恼。',
                },
                {
                  icon: 'ri-global-line',
                  title: '海量资源',
                  desc: '覆盖国产剧、韩剧、美剧、日剧、泰剧、动漫等多元类型，每日更新，与各大平台保持同步。',
                },
                {
                  icon: 'ri-device-line',
                  title: '多端适配',
                  desc: '全面支持电脑、平板、手机等设备，无论在家还是外出，随时随地畅享追剧乐趣。',
                },
                {
                  icon: 'ri-user-heart-line',
                  title: '免费无忧',
                  desc: '无需注册，无需付费，所有电视剧资源全部免费开放，让追剧变得简单纯粹。',
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: '贴心服务',
                  desc: '7×24小时在线客服支持，遇到任何问题都能及时获得帮助，让您追剧无忧。',
                },
              ].map((item, idx) => (
                <div key={idx} className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                  <div className="w-11 h-11 flex items-center justify-center bg-primary-50 rounded-xl mb-4">
                    <i className={`${item.icon} text-xl text-primary-500`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-500">
                听听我们的用户怎么说
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  name: '追剧达人小王',
                  text: '努努影院真的太棒了！资源超全，更新也快，画质清晰而且完全不卡顿。我每天都在这里追剧，已经推荐给身边所有朋友了。',
                  rating: 5,
                },
                {
                  name: '剧迷小李',
                  text: '作为一个韩剧爱好者，努努影院的韩剧资源让我非常满意。字幕准确，播放流畅，关键是全部免费，真的是追剧党的福音。',
                  rating: 5,
                },
                {
                  name: '影视爱好者老张',
                  text: '用了很多追剧平台，努努影院是最让我省心的。界面简洁，分类清晰，不用注册就能直接看，体验非常好。强烈推荐！',
                  rating: 5,
                },
              ].map((review, idx) => (
                <div key={idx} className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "{review.text}"
                  </p>
                  <p className="text-sm font-medium text-foreground-800">
                    — {review.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500">
                有任何问题或建议，欢迎随时联系我们
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-11 h-11 flex items-center justify-center bg-primary-50 rounded-xl mx-auto mb-3">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-600">service@nunumovie.com</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-11 h-11 flex items-center justify-center bg-primary-50 rounded-xl mx-auto mb-3">
                  <i className="ri-customer-service-2-line text-xl text-primary-500"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">在线客服</h3>
                <p className="text-sm text-foreground-600">7×24小时在线</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-11 h-11 flex items-center justify-center bg-primary-50 rounded-xl mx-auto mb-3">
                  <i className="ri-map-pin-line text-xl text-primary-500"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                <p className="text-sm text-foreground-600">北京市朝阳区</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于努努影院",
          "description": "努努影院是国内领先的高清电视剧免费在线观看平台，致力于为追剧爱好者提供最全面流畅的观剧体验。",
          "url": "https://nunumovie.com/about"
        })
      }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://nunumovie.com/" },
            { "@type": "ListItem", "position": 2, "name": "关于我们" }
          ]
        })
      }} />
    </>
  );
}